module.exports = __webpack_public_path__ + "static/assets/solar_health-linear.svg";